import { z } from "zod";
import { CostRuleKind, DocumentKind, ExpenseKind, FscRuleKind, LoadSource, LoadStatus, MembershipStatus, OrgType, PayContractKind, PlanId, Role, SettlementStatus, StopKind, SubscriptionStatus, SyncEntity, TrailerType, Verdict, } from "../enums.js";
export const uuidSchema = z.string().uuid();
export const isoTimestampSchema = z.string().datetime({ offset: true }).or(z.string().datetime());
export const centsSchema = z.number().int().safe();
export const orgTypeSchema = z.nativeEnum(OrgType);
export const roleSchema = z.nativeEnum(Role);
export const membershipStatusSchema = z.nativeEnum(MembershipStatus);
export const loadStatusSchema = z.nativeEnum(LoadStatus);
export const loadSourceSchema = z.nativeEnum(LoadSource);
export const stopKindSchema = z.nativeEnum(StopKind);
export const trailerTypeSchema = z.nativeEnum(TrailerType);
export const documentKindSchema = z.nativeEnum(DocumentKind);
export const expenseKindSchema = z.nativeEnum(ExpenseKind);
export const settlementStatusSchema = z.nativeEnum(SettlementStatus);
export const planIdSchema = z.nativeEnum(PlanId);
export const subscriptionStatusSchema = z.nativeEnum(SubscriptionStatus);
export const verdictSchema = z.nativeEnum(Verdict);
export const syncEntitySchema = z.nativeEnum(SyncEntity);
export const payContractKindSchema = z.nativeEnum(PayContractKind);
export const placeSchema = z.object({
    text: z.string(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    zip: z.string().nullable(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
});
export const fscRuleSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal(FscRuleKind.from_load) }),
    z.object({
        kind: z.literal(FscRuleKind.fixed_per_mile),
        centsPerMile: z.number(),
    }),
]);
export const costRuleSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal(CostRuleKind.per_mile) }),
    z.object({
        kind: z.literal(CostRuleKind.weekly_truck),
        weeklyCents: centsSchema,
    }),
]);
export const syncedRowSchema = z.object({
    id: uuidSchema,
    orgId: uuidSchema,
    version: z.number().int().positive(),
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
});
export const loadPatchSchema = z
    .object({
    status: loadStatusSchema.optional(),
    source: loadSourceSchema.optional(),
    driverId: uuidSchema.nullable().optional(),
    brokerId: uuidSchema.nullable().optional(),
    brokerContactId: uuidSchema.nullable().optional(),
    payContractId: uuidSchema.nullable().optional(),
    refNumber: z.string().nullable().optional(),
    loadDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
    origin: placeSchema.optional(),
    destination: placeSchema.optional(),
    linehaulCents: centsSchema.optional(),
    fscCentsPerMile: z.number().optional(),
    accessorialsCents: centsSchema.optional(),
    loadedMiles: z.number().int().nonnegative().optional(),
    deadheadMiles: z.number().int().nonnegative().optional(),
    weightLb: z.number().int().nullable().optional(),
    widthIn: z.number().int().nullable().optional(),
    heightIn: z.number().int().nullable().optional(),
    lengthIn: z.number().int().nullable().optional(),
    trailerType: trailerTypeSchema.nullable().optional(),
    note: z.string().nullable().optional(),
})
    .strict();
export const quoteInputSchema = z.object({
    linehaulCents: centsSchema,
    fscCentsPerMile: z.number().default(0),
    accessorialsCents: centsSchema.default(0),
    loadedMiles: z.number().int().nonnegative(),
    deadheadMiles: z.number().int().nonnegative().default(0),
    cutBps: z.number().int().nonnegative().default(0),
    kind: payContractKindSchema.default(PayContractKind.lease_pct),
    perLoadedMileCents: z.number().nullable().optional(),
    flatCents: centsSchema.nullable().optional(),
    fscRule: fscRuleSchema.default({ kind: FscRuleKind.from_load }),
    costRule: costRuleSchema.default({ kind: CostRuleKind.per_mile }),
    mpg: z.number().positive(),
    dieselCentsPerGallon: centsSchema,
    otherCentsPerMile: z.number().nonnegative(),
    targetCentsPerMile: z.number().optional(),
    floorCentsPerMile: z.number().optional(),
    routeMinutes: z.number().int().nonnegative().nullable().optional(),
    routeDeadheadMinutes: z.number().int().nonnegative().nullable().optional(),
});
export const syncMutationSchema = z.object({
    mutationId: uuidSchema,
    entity: syncEntitySchema,
    op: z.enum(["upsert", "delete"]),
    id: uuidSchema,
    baseVersion: z.number().int().positive().nullable(),
    patch: z.record(z.unknown()).optional(),
    clientChangedAt: z.string(),
});
//# sourceMappingURL=index.js.map